import axios from 'axios'
import AuthService from './authService'
import App from '../main'
var instance = axios.create();

instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    var token = AuthService.getAuthToken();
    if (token) {
        config.headers['Authorization'] = token;
    }
    return config;
}, function (error) {
    // Do something with request error
    App.$store.commit('setAuthorization', false);
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    // Do something with response data
     App.$store.commit('setAuthorization', true);
    return response;
   
  }, function (error) {
    var status = error.response.status;
    if(status == 401) {
        App.$router.push({name:'Login'});
    }else if(status == 406){
        App.$store.commit('setAuthorization', false);
    }
    // Do something with response error
    return Promise.reject(error);
  });

export default instance;